var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#3498DB",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 18.6667V22.6667M25.8335 18.6667V22.6667",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8333 20.6667H31.1667C26.1383 20.6667 23.6242 20.6667 22.0621 22.2288C20.5 23.7909 20.5 26.3051 20.5 31.3334V34.6667C20.5 39.695 20.5 42.2093 22.0621 43.7713C23.6242 45.3334 26.1383 45.3334 31.1667 45.3334H33.8333C38.8616 45.3334 41.3759 45.3334 42.9379 43.7713C44.5 42.2093 44.5 39.695 44.5 34.6667V31.3334C44.5 26.3051 44.5 23.7909 42.9379 22.2288C41.3759 20.6667 38.8616 20.6667 33.8333 20.6667Z",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 27.3333H43.8332",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 36.6667C28.5 36.6667 30.5 37.3334 31.1667 39.3334C31.1667 39.3334 34.0687 34.0001 37.8333 32.6667",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBooking);
export default __webpack_public_path__ + "static/media/total-booking.5bb822e7bd63f57f25ab027a74b3f6a3.svg";
export { ForwardRef as ReactComponent };